import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import { api } from '../../index';
import Wallboard from '../Wallboard/Wallboard';
import Spinner from '../../Components/Spinner/Spinner'
import { MdOutlineLogout } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { removeCookie } from 'typescript-cookie';
import { toast } from 'react-toastify';

const limit = 100;
const logoutChannel =  new BroadcastChannel('Logout');
let unique = -1;

export const logoutAllTabs = () => {
	logoutChannel.onmessage = () => {
		api.logout();
		window.location.reload();
		logoutChannel.close();
	}
}

const Wallboards = (props: any) => {
	const [token, setToken] = useState(null);
	const [wallboards, setWallboards] = useState([]);
	const navigate = useNavigate();
	const { t } = useTranslation();

	useEffect(() => {
		const user = api.getUser();

		if(api.isLoggedIn() && user) {
			document.title = 'Wallboards | Infinity';
			api.calls.user.wallboard.browse(user.id, { limit })
			.then((wallboards: any) => {
				api.calls.user.wallboard.token.read()
				.then((token : any) => {

					const templates = wallboards.data.templates;

					templates.sort((a: any, b: any) => a.name.localeCompare(b.name));

					setWallboards(templates)
					setToken(token.data.token)
				})

				.catch((r:any) => {
					if(r.response.status == '404') {
						api.calls.user.acl.permission.read(api.user.id)
						.then((r:any) => {
							if(r.data.general[2].permission & 1) {
								api.calls.company.wallboard.token.create(api.user.pbx_company_id, {pbx_user_id: api.user.id})
								.then((r:any) => {
									if(r.status === 200) {
										api.calls.user.wallboard.token.read()
										.then((token : any) => {

											const templates = wallboards.data.templates;

											templates.sort((a: any, b: any) => a.name.localeCompare(b.name));

											setWallboards(templates)
											setToken(token.data.token)
										})
									}
									// eslint-disable-next-line
								}).catch((r: any) => {
									toast.error(t('you_do_not_have_permission'));
								});
							} else {
								toast.error(t('you_are_not_allow_to_create_a_token'));
							}
						})
					}
				})
			})
		} else {
			navigate("/login");
		}

		// eslint-disable-next-line
	}, [])

	if(!wallboards) {
		return <span className='loading-spinner'>
			<Spinner />
		</span>
	}

	const items: any[] = [];
	let temp: any[] = [];

	wallboards.forEach((wallboard: any, index: number) => {
		if(index > 0 && index % 4 === 0) {
			items.push(
				<div className="row" key={index}>
					{temp}
				</div>
			)
			temp = [];
		}

		temp.push(<div key={wallboard.id} className="large-3 medium-3 small-6 columns">
			<Wallboard
				token={token}
				{...wallboard}
			/>
		</div>);
	})

	if(temp.length > 0) {
		items.push(
			<div className="row" key={unique--}>
				{temp}
			</div>
		)
	}

	const winHight = window.innerHeight;
	const finalHeight = (winHight - 64);

	return (
		<div className="small-12 medium-12 large-12 columns wallboard-container">
			<div className='callout'>
				<div className="wallboards" style={{height: finalHeight, overflow:'auto' }}>
					{
						props.logoutBtn === false
						?
							<div className="small-12 medium-12 large-12 columns">
								<MdOutlineLogout
									title={t('logout')}
									className="logout-icon"
									onClick={() => {
										if(api.isLoggedIn()) {
											api.logout()
											navigate("/login")
											logoutChannel.postMessage('Logout');
											removeCookie('wallboardId');
										}
									}}
								/>
							</div>
						:
							null
					}
					<div className="small-12 medium-12 large-12 columns">
						<img src="/www/img/infracom/InfraCom_Ikon_Orange.png" className="wallboard-logo" alt="Logo" />
						{
							token ?
								<p className="text-center">{t('select_a_wallboard')}</p>
							:
								<p className="text-center">{t('you_do_not_have_permission')}</p>
						}
					</div>
					{items}
				</div>
			</div>
		</div>
	)
}

export default Wallboards;
